export default __webpack_public_path__ + "static/media/arrow-thick-right.3958e591.svg";